export const DEFAULT_TAB = {
  id: crypto.randomUUID(),
  text: "",
  icon: "",
};
